import { Component } from "react";
import { Box, Button, CircularProgress, Drawer, IconButton, Stack, Typography } from "@mui/material";
import { MdOutlineClose, MdPlayArrow, MdStop } from "react-icons/md";
import BasicDataGrid from "../ui/BasicDataGrid";
import Inventario from "./Inventario";
import { httpGet, httpPost } from "../util/http";
import dayjs from 'dayjs';
import { INVENTARIO_ABERTO, INVENTARIO_CONCLUIDO, INVENTARIO_EM_CONTAGEM, INVENTARIO_EXPIRADO } from "../util/contants";
import InventStatus from "../ui/InventStatus";
import ReservDialog from "../ui/ReservDialog";
import ErrorDialog from "../ui/ErrorDialog";
import ProdutosAbertosDialog from "../ui/ProdutosAbertosDialog";
import MessageDialog from "../ui/MessageDialog";
import Cookies from "universal-cookie";

export default class DepositoFichaSemanal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            btnLoading: false,
            showDepFicha: false,
            showUnidFicha: false,
            showInventDialog: false,
            showOpenDialog: false,
            reservados: [],
            showReservDialog: false,
            showCloseInventDialog: false,
            showWarningDialog: false,
            err: 'Erro idiota & besta somente para teste.',
            step: 0,
        };

        let cookies = new Cookies();
        this.user = cookies.get('user');

        this.columns = [
            { field: 'data', headerName: 'Data/Horário', flex: 1, valueGetter: (params) => dayjs(params.row?.created_at).format('DD/MM/YYYY - HH:mm') },
            {
                field: 'status', headerName: 'Status', flex: 1, valueGetter: (params) => this.checkStatus(params?.row)
            },
            { field: 'contagens', headerName: 'Nº de contagens', width: 130, valueGetter: (params) => params.row?.contagens?.length },
        ];
    }

    checkStatus(inventario) {
        if (inventario.status == INVENTARIO_EXPIRADO) {
            return 'Expirado';
        }
        if (inventario.encerramento) {
            return 'Concluído';
        }
        if (this.state.deposito?.status == INVENTARIO_CONCLUIDO) {
            return 'Concluído';
        }
        if (this.state.deposito?.status == INVENTARIO_EM_CONTAGEM) {
            return 'Em contagem';
        }
        return 'Aberto';
    }

    componentDidMount() {
        this.refresh();
    }

    refresh() {
        this.setState({ loading: true });
        httpGet('/depositos/' + this.props.deposito?.id + '/readsemanal',
            deposito => {
                console.log(deposito)
                this.setState({
                    deposito,
                    loading: false,
                });
            },
            error => {
                console.log(error);
                this.setState({ loading: false });
            },
        );
    }

    inventstatus(start, produtos) {
        this.setState({ btnLoading: true });
        httpPost('/inventarios/' + this.props.deposito?.id + (start ? '/startsemanal' : '/stopsemanal'),
            start ? {} : { produtos: produtos || [] },

            (data, message) => {
                this.setState({ showProdutosDialog: false });
                this.refresh();
                if (this.props.onRefresh) {
                    this.props.onRefresh();
                }
                this.setState({ btnLoading: false });
            },

            error => {
                this.setState({
                    btnLoading: false,
                    showErrDialog: true,
                    err: error.message,
                    step: 0,
                });
            },

            false
        );
    }

    fecharInventario(produtos) {
        this.setState({ step: INVENTARIO_ABERTO });
        this.inventstatus(false, produtos);
    }

    abrirInventario() {
        this.setState({ showOpenDialog: false });
        const entreTerçaESexta = new Date().getDay() > 1 && new Date().getDay() < 5;
        console.log(entreTerçaESexta)
        if(entreTerçaESexta) {
            this.setState({ showWarningDialog: true });
            return;
        }
        this.inventstatus(true);
    }

    render() {
        return (
            <Drawer open={true} anchor="right">
                <Box height={40}></Box>
                {this.state.showErrDialog && <ErrorDialog onClose={() => this.setState({ showErrDialog: false })} msg={this.state.err} />}
                {this.state.showOpenDialog && <MessageDialog title="ATENÇÃO TOTAL" onConfirm={() => this.abrirInventario()} onClose={() => this.setState({ showOpenDialog: false })} >Tem certeza que deseja iniciar uma nova contagem semanal para este depósito?</MessageDialog>}
                {this.state.showWarningDialog && <MessageDialog title="NÃO É POSSÍVEL CONTINUAR" onClose={() => this.setState({ showWarningDialog: false })} >Não é possível iniciar a Contagem Semanal, dia da semana não autorizado.</MessageDialog>}
                {this.state.showProdutosDialog && <ProdutosAbertosDialog
                    depositoId={this.props.deposito?.id}
                    btnLoading={this.state.btnLoading}
                    onConfirm={(produtos) => this.fecharInventario(produtos)}
                    onClose={() => this.setState({ showProdutosDialog: false })}
                />}
                {this.state.showInventDialog && <Inventario semanal onRefresh={() => this.refresh()} inventario={this.state.currInvent} deposito={this.state.deposito} onClose={e => this.setState({ showInventDialog: false })} />}
                <Stack width={600} p={2} gap={1} flex={1}>
                    <Stack>
                        <Stack direction="row">
                            <Typography color="primary" variant="h6"><b>Ficha do depósito (Contagem Semanal)</b></Typography>
                            <Box flex={1} />
                            <IconButton onClick={e => this.props.onClose(e)} title="Fechar" color="primary"><MdOutlineClose /></IconButton>
                        </Stack>
                        <Stack direction="row" gap={1}>
                            <Typography variant="caption"><b>{this.props.deposito?.nome + ' - '}</b></Typography>
                            <Typography variant="caption"><b>{this.props.deposito?.unidade.nome}</b></Typography>
                        </Stack>
                    </Stack>


                    <Stack direction="row" gap={1}>
                        {this.state.deposito?.status != INVENTARIO_CONCLUIDO ?
                            <Button onClick={e => this.setState({ showProdutosDialog: true })} size="small" startIcon={this.state.btnLoading ? <CircularProgress sx={{ color: 'rgba(0, 0, 0, 0.26)' }} size={20} /> : <MdStop />} color="error" variant="contained" disableElevation disabled={this.state.loading || (this.state.deposito?.status == INVENTARIO_EM_CONTAGEM) || (this.user.isEncarregado)}>Encerrar semanal</Button> :
                            <Button onClick={e => this.setState({ showOpenDialog: true })} size="small" startIcon={this.state.btnLoading ? <CircularProgress sx={{ color: 'rgba(0, 0, 0, 0.26)' }} size={20} /> : <MdPlayArrow />} color="success" variant="contained" disableElevation disabled={this.state.loading || this.state.btnLoading}>Iniciar semanal</Button>
                        }
                    </Stack>
                    <Stack maxHeight="calc(100vh - 280px)" flex={1}>
                        <BasicDataGrid
                            props={{
                                onRowClick: e => this.setState({ showInventDialog: true, currInvent: e.row }),
                                loading: this.state.loading
                            }} rows={this.state.deposito?.inventarios ? this.state.deposito?.inventarios : []} columns={this.columns} />
                    </Stack>
                </Stack>
            </Drawer>
        );
    }
}
